module.exports = __webpack_public_path__ + "img/cleaning_services.038aaf19.jpg";